import { TAPIQueryKeys } from 'common/api-calls/common-api-types.ts';
import { APIPartySuggestion } from 'src/common/api-calls/delivery-request/new/types';
import { userSpecificApiKey } from 'src/common/utils/apicall/api-key';

const featureApiKey = userSpecificApiKey('delivery-request-submission');

type Keys = {
  all: never;
  preview: {
    origin: string;
    destination: string;
    waitingTime: number;
  };
  submit: never;
  partySuggestion: APIPartySuggestion['queries'];
};

// todo: move to utils
function getKeys<k extends keyof Keys>(key: keyof Keys) {
  return (params?: Keys[k]) => (params ? [featureApiKey, key, ...Object.values(params)] : [featureApiKey, key]);
}

export const apiKeyDeliveryRequestSubmission: TAPIQueryKeys<Keys> = {
  all: () => [featureApiKey],
  preview: getKeys('preview'),
  submit: getKeys('submit'),
  partySuggestion: getKeys('partySuggestion'),
};
